import { normalizeModulePath } from "./moduleDefaultPath";

/** 與 DropDownOption getDisplayTitle 一致 */
export function getMenuDisplayTitle(menuItem) {
  if (!menuItem) return "";
  return menuItem.displayTitle || menuItem.title || "";
}

/** 術前／付款同意書／問卷單子項：子側邊欄名稱 + 括號簡稱 */
const CONSENT_GROUP_LABEL_SUFFIX = {
  "consent-templates": "術前",
  "payment-consent-template": "付款",
  "questionnaire-templates": "問卷",
};

function buildConsentChildLabel(parentEng, childTitle) {
  const suffix = CONSENT_GROUP_LABEL_SUFFIX[parentEng];
  if (!suffix) return childTitle;
  return `${childTitle}（${suffix}）`;
}

/**
 * 從 DefaultLayout menuBarList 扁平化可設為首頁的子頁（path + label）。
 * @param {Array} menuBarSections
 * @param {string} routerName
 */
export function flattenMenuBarDefaultHomeOptions(menuBarSections, routerName) {
  if (!Array.isArray(menuBarSections) || !routerName) return [];

  const results = [];
  const seen = new Set();

  function add(path, label) {
    const normalized = normalizeModulePath(path);
    if (!normalized || seen.has(normalized)) return;
    seen.add(normalized);
    results.push({ path: normalized, label });
  }

  function walkItems(items) {
    for (const item of items) {
      if (!item || item.eng === "manual") continue;

      if (item.items?.length) {
        for (const subItem of item.items) {
          if (subItem.items?.length) {
            for (const leaf of subItem.items) {
              add(
                `/${routerName}/${leaf.eng}`,
                getMenuDisplayTitle(leaf)
              );
            }
          } else {
            add(
              `/${routerName}/${subItem.eng}`,
              buildConsentChildLabel(item.eng, getMenuDisplayTitle(subItem))
            );
          }
        }

        if (!item.groupOnly && item.eng !== "message") {
          add(`/${routerName}/${item.eng}`, getMenuDisplayTitle(item));
        }
      } else {
        add(`/${routerName}/${item.eng}`, getMenuDisplayTitle(item));
      }
    }
  }

  for (const section of menuBarSections) {
    walkItems(section.items || []);
  }

  return results;
}

export function menuEngMatchesDefaultHomePath(
  defaultHomePath,
  routerName,
  eng
) {
  if (!defaultHomePath || !routerName || !eng) return false;
  return (
    normalizeModulePath(defaultHomePath) ===
    normalizeModulePath(`/${routerName}/${eng}`)
  );
}
